<template lang="pug">
section
  div
    | The fee for a sponsor licence
    | depends on the size and type of organisation:

  ul
    li
      | £536 for a small company or a charity;
    li
      | £1,476 for a medium or large company.

  br

  div
    | Companies qualify as “small”,
    | if they satisfy two or more
    | of the following requirements in a year:

  ul
    li
      | annual turnover is less than £10.2 million;
    li
      | total assets is less than 5.1 million;
    li
      | Number of employees is less than 50.
</template>

<script>
export default {
  name: "submit_oa_form",
};
</script>